import { isEmpty } from 'ramda';
import { isFunction } from 'ramda-extension';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from '../../contexts/translation';
import { Columns } from '../../pages/Reports/AssetResponsiblePerson/Columns';
import { SisDataGrid } from '../table';
import { IDataGrid } from './AssetsDataGrid';

interface Props extends IDataGrid {
  heading: string;
  filterVisibility: boolean;
  setFilterVisibility: (e: boolean) => void;
}

export const ResponsiblePersonDataGrid = ({
  data,
  dataGridRef,
  resetFilter,
  heading,
  filterVisibility,
  setFilterVisibility,
}: Props) => {
  const transFormName = 'ResponsiblePersonReport';
  const { translate } = useTranslation();
  const transFormReportBar = 'Reports.Bar';

  const hasFilterRef = useRef(false);
  const toolbarBaseItemsRef = useRef<any[] | null>(null);

  const onToolbarPreparing = (e) => {
    if (!Array.isArray(e.toolbarOptions.items)) return;

    e.toolbarOptions.items.unshift(
      {
        location: 'before',
        text: heading,
        visible: !filterVisibility,
      });


    e.toolbarOptions.items.unshift({
      name: "activeFilterTitle",
      cssClass: "title",
      template: () => `<span class="datagrid-active-filter">${translate!('You have active filter', transFormReportBar)}</span>`,
      visible: false,
    });


    e.toolbarOptions.items.unshift(
      {
        location: 'after',
        widget: 'dxButton',
        options: {
          icon: 'clear',
          type: 'info',
          text: translate!('Clear filter', transFormName),
          stylingMode: 'outlined',
          onClick: () => {
            if (resetFilter && isFunction(resetFilter)) {
              resetFilter();
            }
          },
        },
      },
      {
        location: 'after',
        widget: 'dxButton',
        options: {
          visible: true,
          text: translate!(filterVisibility ? 'Hide' : 'Show', transFormReportBar),
          type: 'normal',
          onClick: () => setFilterVisibility(!filterVisibility),
        },
      },
    );

    toolbarBaseItemsRef.current = [...(e.toolbarOptions.items || [])];
  };

  const updateToolbarBadge = (grid: any, hasFilter: boolean) => {
    const base = toolbarBaseItemsRef.current;
    const current = grid.option("toolbar.items") || [];
    const baseline = base ?? current;
    const idx = baseline.findIndex((it: any) => it?.name === "activeFilterTitle");
    if (idx === -1) return;

    grid.option(`toolbar.items[${idx}].visible`, hasFilter);
  };

  const handleOptionChanged = (e: any) => {
    const grid = e.component;

    setTimeout(() => {
      const combined = grid.getCombinedFilter();
      const hasFilterNow = !!combined;

      if (hasFilterRef.current !== hasFilterNow) {
        hasFilterRef.current = hasFilterNow;
        updateToolbarBadge(grid, hasFilterNow);
      }
    }, 1000);
  };
  return (
    <SisDataGrid
      enableXlsxExport
      exportName={'responsible-person-data'}
      show={!isEmpty(data)}
      dataGridRef={dataGridRef}
      data={data}
      keyExpr={'assetId'}
      transFormName={transFormName}
      columns={Columns}
      onToolbarPreparing={onToolbarPreparing}
      pageSizeChangeVisible={true}
      onOptionChanged={handleOptionChanged}
    />
  );
};
